var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowIconDelivery(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.777 14.261a.832.832 0 01.648-.259h6.482c.518 0 .907.39.907.908a.886.886 0 01-.907.907H8.425a.886.886 0 01-.908-.907c0-.26.065-.454.26-.649z",
    fill: "#CACACA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.26 7.778a.832.832 0 01.648-.259c.519 0 .907.389.907.908v6.481a.886.886 0 01-.907.908.886.886 0 01-.907-.908V8.427c0-.26.064-.454.259-.649z",
    fill: "#CACACA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.887 3.89c.39-.389.908-.389 1.297 0l10.37 10.372c.39.388.39.907 0 1.296-.388.389-.906.389-1.296 0L3.889 5.187c-.39-.39-.39-.908 0-1.297z",
    fill: "#CACACA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIconDelivery);
export default __webpack_public_path__ + "static/media/arrow-icon-delivery.04b7a19aa254be2c8168eb5f07f151c3.svg";
export { ForwardRef as ReactComponent };